import { IncomingMessage } from 'http';
import { encode } from 'querystring';

import { fechFromBPartsApi } from '../utils';

export const searchProducts = async (
  {
    locale,
    carIdentifier,
    partIdentifier,
    page,
    sort,
    reference,
    min_price,
    max_price,
    detailed_prices = 'false',
  }: {
    locale: string;
    partIdentifier: string;
    carIdentifier: string;
    page: string;
    sort: string;
    reference: string;
    min_price: string;
    max_price: string;
    detailed_prices: string;
  },
  req?: IncomingMessage
): Promise<TProductSearch> => {
  return fechFromBPartsApi<TProductSearch>(
    `/${locale}/shop/products/search?${encode({
      car_identifier: carIdentifier,
      part_identifier: partIdentifier,
      page: page,
      sort,
      reference,
      min_price,
      max_price,
      detailed_prices: detailed_prices,
    })}`,
    {
      headers: req ? new Headers(req.headers as HeadersInit) : undefined,
      credentials: 'include',
    },
    { enableCustomErrorWrapper: true }
  );
};
